export const translateLinks = () => {
  [...document.querySelectorAll("[data-link-translate-me]")].map((link) => {
    const urlsDict = {
      de: "https://action.wemove.eu/donate/spenden-wemove",
      en: "https://action.wemove.eu/donate/chip-in-wemove",
      es: "https://action.wemove.eu/donate/apoyar-nuestro-trabajo",
      fr: "https://action.wemove.eu/donate/don-wemove",
      it: "https://action.wemove.eu/donate/sotieni-wemove",
      nl: "https://action.wemove.eu/donate/doneren-wemove",
      pl: "https://action.wemove.eu/donate/dorzuc-sie-wemove",
    };

    link.href = urlsDict[window.wemove.page.language.iso];
  });
};
